import React, { useEffect, useState } from "react";
import { Box, Button, Dialog, Typography } from "@mui/material";
import InputWithLabel from "../../shared/components/InputWithLabel";
import CustomPrimaryButton from "../../shared/components/CustomPrimaryButton";
import * as api from "../../api";

const ServerInviteDialog = ({ open, onClose, server }) => {
  const [identifier, setIdentifier] = useState("");
  const [status, setStatus] = useState("");
  const [outgoingInvitations, setOutgoingInvitations] = useState([]);

  const loadOutgoingInvitations = () => {
    if (!server?.id) {
      return;
    }
    api.getOutgoingServerInvitations(server.id).then((response) => {
      if (!response.error) {
        setOutgoingInvitations(response.data.invitations);
      }
    });
  };

  useEffect(() => {
    if (open) {
      setIdentifier("");
      setStatus("");
      loadOutgoingInvitations();
    }
  }, [open, server]);

  const handleClose = () => {
    setIdentifier("");
    setStatus("");
    onClose();
  };

  const handleInvite = async () => {
    const response = await api.sendServerInvitation({
      serverId: server.id,
      targetIdentifier: identifier.trim(),
    });

    if (response.error) {
      setStatus(response.exception?.response?.data || "Не удалось отправить приглашение");
      return;
    }

    setStatus("Приглашение отправлено");
    setIdentifier("");
    loadOutgoingInvitations();
  };

  const handleRevoke = async (invitationId) => {
    const response = await api.revokeServerInvitation({ serverId: server.id, invitationId });
    if (!response.error) {
      setOutgoingInvitations((items) => items.filter((item) => item._id !== invitationId));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          bgcolor: "#282a30",
          color: "#f2f3f5",
          borderRadius: "8px",
          width: "460px",
          p: "24px",
        },
      }}
    >
      <Typography sx={{ fontSize: "20px", fontWeight: 700 }}>
        Пригласить
      </Typography>
      <InputWithLabel
        label="Username или e-mail"
        type="text"
        value={identifier}
        setValue={setIdentifier}
        placeholder=""
      />
      {status && (
        <Typography sx={{ color: "#b5bac1", mt: "12px", fontSize: "14px" }}>
          {status}
        </Typography>
      )}
      <Box sx={{ display: "flex", gap: "12px", mt: "18px" }}>
        <CustomPrimaryButton
          label="Закрыть"
          onClick={handleClose}
          additionalStyles={{ background: "#4e5058" }}
        />
        <CustomPrimaryButton
          label="Отправить"
          onClick={handleInvite}
          disabled={identifier.trim().length < 3}
        />
      </Box>
      <Typography sx={{ fontSize: "16px", fontWeight: 800, mt: "24px" }}>
        Отправленные
      </Typography>
      <Box sx={{ mt: "8px", maxHeight: "220px", overflow: "auto" }}>
        {outgoingInvitations.length === 0 && (
          <Typography sx={{ color: "#8e9297", fontSize: "14px" }}>
            Нет отправленных приглашений
          </Typography>
        )}
        {outgoingInvitations.map((invitation) => (
          <Box
            key={invitation._id}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              bgcolor: "#1f2024",
              borderRadius: "6px",
              p: "10px",
              mb: "8px",
            }}
          >
            <Box>
              <Typography sx={{ fontWeight: 700 }}>
                {invitation.receiverId?.displayName || invitation.receiverId?.username}
              </Typography>
              <Typography sx={{ color: "#8e9297", fontSize: "12px" }}>
                @{invitation.receiverId?.username}
              </Typography>
            </Box>
            <Button
              onClick={() => handleRevoke(invitation._id)}
              sx={{ color: "#f97316", textTransform: "none", fontWeight: 800 }}
            >
              Отозвать
            </Button>
          </Box>
        ))}
      </Box>
    </Dialog>
  );
};

export default ServerInviteDialog;
